import { Button, Text } from "../uikit";
import { motion } from "motion/react";
import { useNavigate } from "react-router";
import Card from "../components/Card";
import { routeVariants } from "../routesVariants";
import { useTranslation } from "react-i18next";

export default function PaymentStatus() {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();

  return (
    <motion.div
      className="container background-regular border-padding column-spacing column"
      variants={routeVariants}
      initial="initial"
      animate="final"
      exit="exit"
    >
      <Card>
        <div className="column card">
          <div className="row center">
            <Text weight="2">{t("Payment is being verified")}</Text>
          </div>
          <Button mode="outline" size="l" className="row mt-1" onClick={() => navigate("/account")}>
            {t("Go to account")}
          </Button>
        </div>
      </Card>
    </motion.div>
  );
}
